module.exports = __webpack_public_path__ + "static/media/insta.533753ab.svg";